import { useState } from "react";

export const ImgLoader = ({ src, placeHolder }) => {
    const [imgLoading, setImgLoading] = useState(true);

    return (
        <div className='img-loader'>
            {imgLoading && placeHolder}
            <img style={{ display: imgLoading ? 'none' : 'block' }} onLoad={() => { setImgLoading(false) }} src={src} alt="" />
        </div>
    )
}

